import { Link } from "react-router-dom";
import { useAuth } from "../auth/context";

// Spec §4.2: when the refresh token has also expired, "the app shows a
// non-blocking banner asking the user to re-authenticate, but continues to
// allow local read/write until they do."
export function ReauthBanner() {
  const { state } = useAuth();
  if (state.status !== "reauth_required") return null;
  const who = state.user?.email ? ` as ${state.user.email}` : "";
  return (
    <div className="sticky top-0 z-10 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200">
      Your session expired{who}. Local changes will be saved and synced once
      you sign in again.{" "}
      <Link to="/signin" className="font-medium underline">
        Sign in
      </Link>
    </div>
  );
}
